
// 管理端-- 路由
export default [
  {
    path: '/manage',
    name: 'manage',
    component: resolve => require(['@/views/manage/home/index'], resolve),
    meta: {
      name: '首页'
    }
  },
  {
    path: '/workDynamics',
    name: 'workDynamics',
    component: resolve => require(['@/views/officalweb/workDynamics/index'], resolve),
    meta: {
      name: '工作动态'
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/modules/manage.js